import Transfer from "./transfer";
export default {
  transfer: Transfer,
};
